import { jsPDF } from 'jspdf'

import { addCoverPage } from '@/pdf/pages/CoverPage'
import { addDistributionPage } from '@/pdf/pages/DistributionPage'
import { addMetricsPage } from '@/pdf/pages/MetricsPage'
import { addAudiencePage } from '@/pdf/pages/AudiencePage'
import { AudienceParams } from '@/pdf/types'

export default class PdfBuilder {
    static async buildCoverPdf(parametros: AudienceParams): Promise<ArrayBuffer> {
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        })

        await addCoverPage(pdf, parametros)
        await addMetricsPage(pdf, parametros)
        await addAudiencePage(pdf, parametros)
        await addDistributionPage(pdf, parametros)

        return pdf.output('arraybuffer')
    }
}
